<template>
  <div class="main">
    <Header
      :show="true"
      title="发货记录"
      left="prepage"
      :click-left="handleClickLeft"
    />
    <div class="content">
      <van-cell-group>
        <van-field
          v-model.trim="listQuery.data.singleNo"
          label="任务编号"
          placeholder="请输入"
        />
        <van-field
          v-model.trim="listQuery.data.vehicleNo"
          label="车牌号"
          placeholder="请输入"
        />
        <van-field
          v-model.trim="listQuery.data.driverName"
          label="驾驶员"
          placeholder="请输入"
        />
      </van-cell-group>
      <div style="padding: 16px">
        <van-button
          round
          block
          type="info"
          :loading="table.loading"
          @click="handleQuery"
        >
          查询
        </van-button>
      </div>
      <el-table
        ref="table"
        size="small"
        :loading="table.loading"
        :data="table.data"
        style="width: 100%"
        @row-click="onTableRowClick"
      >
        <el-table-column
          type="expand"
          width="30px"
          align="center"
        >
          <template slot-scope="{ row }">
            <el-form
              label-position="left"
              label-width="100px"
              class="table-expand-form"
            >
              <el-form-item label="任务编号">
                <span>{{ row.singleNo }}</span>
              </el-form-item>
              <el-form-item label="客户名称">
                <span>{{ row.customer }}</span>
              </el-form-item>
              <el-form-item label="项目名称">
                <span>{{ row.projectName }}</span>
              </el-form-item>
              <el-form-item label="施工部位">
                <span>{{ row.consPos }}</span>
              </el-form-item>
              <el-form-item label="方量">
                <span>{{ row.mete }}</span>
              </el-form-item>
              <el-form-item label="车牌号">
                <span>{{ row.vehicleNo }}</span>
              </el-form-item>
              <el-form-item label="车号">
                <span>{{ row.vehicleName }}</span>
              </el-form-item>
              <el-form-item label="司机">
                <span>{{ row.driverName }}</span>
              </el-form-item>
              <el-form-item label="签收人">
                <span>{{ row.signee }}</span>
              </el-form-item>
              <el-form-item label="签收照片">
                <van-image
                  v-if="row.signUrl"
                  width="20vw"
                  height="20vw"
                  style="margin-right: 16px"
                  fit="cover"
                  :src="row.signUrl"
                  @click="openPreview(row.signUrl)"
                />
              </el-form-item>
              <el-form-item label="退砼状态">
                <el-tag
                  v-if="!row.isReturnConcrete"
                  type="info"
                >
                  未退砼
                </el-tag>
                <el-tag
                  v-else
                  type="success"
                >
                  已退砼
                </el-tag>
              </el-form-item>
              <el-form-item label="货物状态">
                <template #default>
                  <el-tag
                    v-if="row.status == 0"
                    type="info"
                  >
                    待装车
                  </el-tag>
                  <el-tag
                    v-if="row.status == 1"
                    type="warning"
                  >
                    装车中
                  </el-tag>
                  <el-tag
                    v-if="row.status == 2"
                    type="warning"
                  >
                    运输中
                  </el-tag>
                  <el-tag
                    v-if="row.status == 3"
                    type="primary"
                  >
                    已到达
                  </el-tag>
                  <el-tag
                    v-if="row.status == 4"
                    type="success"
                  >
                    已签收
                  </el-tag>
                </template>
              </el-form-item>
              <el-form-item label="短链地址">
                <a
                  :href="'http://' + row.shortUrl"
                  target="_blank"
                >{{
                  row.shortUrl
                }}</a>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column
          label="序号"
          type="index"
          align="center"
          width="60"
        />
        <el-table-column
          label="车牌号"
          props="vehicleNo"
          align="center"
          width="100"
        >
          <template slot-scope="{ row }">
            {{ row.vehicleNo }}
          </template>
        </el-table-column>
        <el-table-column
          label="驾驶员"
          props="driverName"
          align="center"
          width="100"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            {{ row.driverName }}
          </template>
        </el-table-column>
        <el-table-column
          label="状态"
          prop="status"
          align="center"
        >
          <template slot-scope="{ row }">
            <el-tag
              v-if="row.status == 0"
              type="info"
            >
              待装车
            </el-tag>
            <el-tag
              v-if="row.status == 1"
              type="warning"
            >
              装车中
            </el-tag>
            <el-tag
              v-if="row.status == 2"
              type="warning"
            >
              运输中
            </el-tag>
            <el-tag
              v-if="row.status == 3"
              type="primary"
            >
              已到达
            </el-tag>
            <el-tag
              v-if="row.status == 4"
              type="success"
            >
              已签收
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-show="table.total > 0"
        :total="table.total"
        background
        layout="prev, pager, next"
        :current-page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        style="margin: 0.6rem 0; text-align: center"
        @current-change="handleQuery"
      />
    </div>
    <Footer value="service" />
    <van-image-preview
      v-model="showPreview"
      :images="showPreviewList"
      :overlay-style="{ backgroundColor: 'rgba(0,0,0,0.7)'}"
    >
      <template #index>
        签收人签名照片
      </template>
    </van-image-preview>
  </div>
</template>
<script>
import { showPhoneAlarm } from "@/global/function.js";
import checkPermission from "@/utils/permission";

import Header from "@/views/components/header/index.vue";
import Footer from "@/views/components/footer/index.vue";

import { getList } from "@/api/ship-record";

export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      listQuery: {
        limit: 10,
        page: 1,
        data: {
          singleNo: "",
          vehicleNo: "",
          driverName: "",
        },
      },
      table: {
        loading: false,
        key: "table",
        total: 0,
        data: [],
      },
      showPreview: false,
      showPreviewList: [],
    };
  },
  computed: {},
  created() {
    this.handleQuery();
  },
  methods: {
    checkPermission,
    handleClickLeft() {
      this.$router.go(-1);
    },
    handleQuery() {
      const { limit, page, data } = this.listQuery;
      const payload = { ...data, limit, page };
      this.table.loading = true;
      getList(payload)
        .then(({ data }) => {
          const {
            page: { total, records },
          } = data;

          this.table.data = records;
          this.table.total = total;
        })
        .finally(() => {
          this.table.loading = false;
        });
    },
    onDateQueryChoose(val) {
      this.listQuery.data.date = val;
      this.listQuery.showCalendar = false;
    },
    onStatusQueryChoose(val) {
      this.listQuery.data.detectStatus = val.value;
      this.listQuery.showStatusActionSheet = false;
    },
    onTableRowClick(row) {
      this.$refs.table.toggleRowExpansion(row);
    },
    handleClickUpdate(row) {
      this.$router.push({
        path: "/service/business/owdr/create",
        query: row,
      });
    },
    openPreview(img) {
      this.showPreview = true;
      this.showPreviewList = [img];
    },
  },
};
</script>
<style lang="less" scoped>
::v-deep .van-cell__title {
  max-width: 30%;
  font-size: 2vh;
}
::v-deep .van-cell__value {
  max-width: 70%;
}
.content {
  padding-bottom: 80px;
}
.table-expand-form {
  padding: 0 12px;

  .el-form-item {
    margin: 4px 0px;
  }
}
</style>
